































































import Vue from "vue";
import { mapState, mapActions } from "vuex";
import { ProductTabFilterOptions, PageConfig } from "../../types";
import { encodeQueryParams } from "@canvas/api/lib/utils";
import ProductTable from "../ProductTable.vue";
import SKUNameRenderer from "../TableRenderers/SKUNameRenderer.vue";
import AvailabilityRenderer from "../TableRenderers/AvailabilityRenderer.vue";
import TableActionEditRenderer from "../TableRenderers/TableActionEditRenderer.vue";
import NameRenderer from "../TableRenderers/NameRenderer.vue";

export default Vue.extend({
  name: "manage-products",
  components: {
    ProductTable
  },
  data(): { [key: string]: any } {
    return {
      productTabItems: ProductTabFilterOptions,
      activeTab: ProductTabFilterOptions[0],
      searchData: {
        searchText: "",
        option: ""
      },
      productTableColumns: [
        {
          name: "sku_name",
          display_name: "PRODUCT NAME",
          fixed: false,
          width: 50,
          headrenderer: null,
          cellrenderer: SKUNameRenderer
        },
        {
          name: "sku_code",
          display_name: "PRODUCT CODE",
          fixed: false,
          width: 25,
          headrenderer: null,
          cellrenderer: NameRenderer
        },
        {
          name: "availability",
          display_name: "AVAILABILITY",
          fixed: false,
          width: 25,
          headrenderer: null,
          cellrenderer: AvailabilityRenderer
        }
        // {
        //   name: "action",
        //   display_name: "",
        //   fixed: false,
        //   width: 20,
        //   headrenderer: null,
        //   cellrenderer: NameRenderer
        // }
      ]
    };
  },
  provide(): any {
    return {
      actionHandler: this.handleTableAction,
      activeTab: this.getActiveTab
    };
  },
  computed: {
    ...mapState("uiModule", {
      modalElement: "modalElement"
    }),
    ...mapState("appModule", {
      selectedEc: "selectedEc",
      productTableData: "inventoryProductSearchResult"
    })
  },
  methods: {
    ...mapActions("appModule", ["searchInventoryProducts"]),
    tabClicked(eventData: { tabKey: string }): void {
      this.activeTab = this.productTabItems.find((tabItem: { key: string }) => {
        return tabItem.key === eventData.tabKey;
      });
      this.updateRoute();
    },
    goToaddNewItem() {
      this.$router.push({ path: "/" + this.selectedEc.name + "/add" });
    },
    updateRoute() {
      const query = {
        [this.searchData.option.name]: this.searchData.searchText,
        status: this.activeTab.name,
        limit: this.productTableData.pageConfig.limit,
        offset: this.productTableData.pageConfig.offset,
        ec_id__in: this.selectedEc.name
      };
      this.productTableData.pageConfig.query = encodeQueryParams(query);
      const routeLink =
        "/" +
        this.selectedEc.name +
        "/inventory/" +
        JSON.stringify({
          data: "Inventory",
          search: this.searchData,
          status: this.activeTab,
          pageConfig: this.productTableData.pageConfig
        });
      this.$router.push({
        path: routeLink
      });
    },
    searchProduct() {
      const query = {
        [this.searchData.option.name]: this.searchData.searchText,
        status: this.activeTab.name,
        limit: this.productTableData.pageConfig.limit,
        offset: this.productTableData.pageConfig.offset,
        ec_id__in: this.selectedEc.name
      };
      this.productTableData.pageConfig.query = encodeQueryParams(query);
      return this.searchInventoryProducts(this.productTableData.pageConfig);
    },
    getActiveTab() {
      return this.activeTab;
    },
    handleTableAction(actionType: string, data: any) {
      switch (actionType) {
        case "request":
          break;
        case "rowselect":
          //route to product details
          this.$emit("updateRoute", { to: "skus", data: data });
          break;
        case "edit":
          //route to product details
          this.$emit("updateRoute", { to: "skus", data: data });
          break;
        case "pageIncrease":
        case "pageDecrease":
        case "goToPage":
          this.productTableData.pageConfig.offset =
            this.productTableData.pageConfig.limit * (data - 1);
          this.productTableData.pageConfig.page = data;
          this.updateRoute();
          break;
        case "setPageLength":
          this.productTableData.pageConfig.limit = data;
          this.productTableData.pageConfig.page = 1;
          this.productTableData.pageConfig.offset = 0;
          this.updateRoute();
          break;
      }
    },
    initManageProducts() {
      this.$store.dispatch("appModule/updateBreadcrumb", {
        data: {
          name: "inventory",
          display_name: "Inventory",
          href: "",
          routerLink: this.$router.currentRoute.path
        },
        router: this.$router
      });
      const parsedJSONData = JSON.parse(
        this.$router.currentRoute.params.searchQuery
      );
      this.searchData = parsedJSONData.search ? parsedJSONData.search : {};
      this.productTableData.pageConfig = parsedJSONData.pageConfig
        ? parsedJSONData.pageConfig
        : PageConfig;
      this.activeTab = parsedJSONData.status
        ? parsedJSONData.status
        : this.productTabItems[0];
    }
  },
  beforeRouteUpdate(to, from, next) {
    next();
    if (to.path !== from.path) {
      this.initManageProducts();
      this.searchProduct();
    }
  },
  mounted() {
    this.initManageProducts();
  }
});
